import { createReducer, ActionType } from "typesafe-actions";
import { merge } from "lodash-es";
import * as actions from "./actions";
import initialState from "./state";
import { StandardsState, FetchedStandard } from "./types";

type Action = ActionType<typeof actions>;

const reducer = createReducer<StandardsState, Action>(initialState)
  .handleAction(actions.fetchRootStandards.request, (state) => ({
    ...state,
    loading: state.rootIds.length === 0,
  }))
  .handleAction(
    actions.fetchRootStandards.success,
    (state, { payload: { data } }) => ({
      ...state,
      loading: false,
      byId: merge(
        state.byId,
        data.reduce<{ [key: string]: FetchedStandard }>(
          (obj, current) => ({
            ...obj,
            [current.id]: current,
          }),
          {},
        ),
      ),
      rootIds: data.map((standard) => standard.id),
    }),
  )
  .handleAction(actions.fetchRootStandards.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(
    actions.fetchStandards.request,
    (state, { payload: { id } }) => ({
      ...state,
      loading: !state.byId[id as string],
    }),
  )
  .handleAction(
    actions.fetchStandards.success,
    (state, { payload: { data, searchTotalCount } }) => ({
      ...state,
      loading: false,
      searchTotalCount,
      searchIds: data.map((standard) => standard.id),
      byId: merge(
        state.byId,
        data.reduce<{ [key: string]: FetchedStandard }>(
          (obj, current) => ({
            ...obj,
            [current.id]: current,
          }),
          {},
        ),
      ),
    }),
  )
  .handleAction(actions.fetchStandards.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(
    actions.fetchSingleStandard,
    (state, { payload: { standard } }) => ({
      ...state,
      byId: merge(state.byId, { [standard.id]: standard }),
    }),
  )
  .handleAction(
    actions.fetchStandardChildren,
    (state, { payload: { standards, id } }) => ({
      ...state,
      byId: merge(
        state.byId,
        { [id]: { standardIds: standards.map((standard) => standard.id) } },
        standards.reduce<{ [key: string]: FetchedStandard }>(
          (obj, current) => ({
            ...obj,
            [current.id]: current,
          }),
          {},
        ),
      ),
    }),
  )
  .handleAction(
    actions.fetchStandardScopes,
    (state, { payload: { elements, elementParts, id } }) => ({
      ...state,
      byId: merge(state.byId, { [id]: { elements, elementParts } }),
    }),
  );

export default reducer;
